module.exports = __webpack_public_path__ + "img/blog-1.0d657fc0.jpg";